import Button from "@/components/Atoms/Button";
import Typography from "@/foundation/Typography/V2";

import { classNameGenerator, clsx } from "@/utils";

import styles from "./PackageCard.module.scss";

interface PackageCardProps {
  currencySymbol: string;
  price: number | `${number}`;
  duration: string;
  noOfConsultations: string;
  setShowBookSlotModal: (showBookSlotModal: any) => void;
  index: number;
  activePackIndex: number;
  setActivePackIndex: (activePackIndex: number) => void;
  points?: string[];
}

const PackageCard: React.FC<PackageCardProps> = (props) => {
  const {
    currencySymbol,
    price,
    duration,
    noOfConsultations,
    setShowBookSlotModal,
    index,
    activePackIndex,
    setActivePackIndex,
    points,
  } = props;

  const cls = classNameGenerator(styles);

  return (
    <div
      className={clsx(
        cls("packageCard"),
        activePackIndex === index ? cls("active") : ""
      )}
      onMouseEnter={() => setActivePackIndex(index)}
    >
      {price !== null && currencySymbol && <Typography
        variant="paragraph1"
        className={cls("price")}
        dangerouslySetInnerHTML={{ __html: `${currencySymbol}${price}` }}
      />}
      <Typography variant="heading4" className={cls("title")}>
        {duration} Plan
      </Typography>
      {points?.length ? (
        <div className={cls("points")}>
          {points?.map((point, index) => (
            <Typography
              key={index}
              variant="paragraph1"
              className={cls("point")}
              dangerouslySetInnerHTML={{ __html: point }}
            />
          ))}
        </div>
      ) : (
        <Typography variant="paragraph1" className={cls("description")}>
          With this plan you get <br />
          <strong>{noOfConsultations} Consultations</strong> with your assigned
          Nutritionist
        </Typography>
      )}
      <div className={cls("actionButtons")}>
        <Button
          variant="outline"
          className={cls("actionButton")}
          onClick={() =>
            setShowBookSlotModal({
              packageData: props,
            })
          }
        >
          Pay now
        </Button>
      </div>
    </div>
  );
};

export default PackageCard;
